// src/pages/Privacy.jsx

import React from "react";

export default function Privacy() {
  return (
    <main className="min-h-screen bg-[#F7F4EA] px-4 py-8 text-[#1E2A38]">
      <div className="mx-auto max-w-3xl rounded-2xl bg-white p-6 shadow-md md:p-10">
        <h1 className="mb-2 text-3xl font-bold">TeamKitty Privacy Policy</h1>

        <p className="mb-6 text-sm text-slate-500">
          <strong>Effective Date:</strong>{" "}
          {new Date().toISOString().slice(0, 10)}
        </p>

        <p className="mb-4">
          TeamKitty respects your privacy and is committed to protecting your
          personal information.
        </p>

        <h2 className="mt-6 mb-2 text-xl font-semibold">
          1. Information We Collect
        </h2>

        <p className="mb-4">
          We may collect information including:
        </p>

        <ul className="mb-4 ml-6 list-disc">
          <li>name and email address</li>
          <li>team and club information</li>
          <li>payment and transaction records</li>
          <li>login and authentication information</li>
          <li>device, browser and usage information</li>
        </ul>

        <h2 className="mt-6 mb-2 text-xl font-semibold">
          2. How We Use Information
        </h2>

        <p className="mb-4">
          We use information to:
        </p>

        <ul className="mb-4 ml-6 list-disc">
          <li>operate and improve TeamKitty</li>
          <li>manage accounts and authentication</li>
          <li>process payments and balance tracking</li>
          <li>support team and club administration</li>
          <li>maintain security and prevent misuse</li>
          <li>communicate important service information</li>
        </ul>

        <h2 className="mt-6 mb-2 text-xl font-semibold">
          3. Payment Providers
        </h2>

        <p className="mb-4">
          Payments may be processed by third-party providers such as Stripe.
          TeamKitty does not store full credit card details.
        </p>

        <h2 className="mt-6 mb-2 text-xl font-semibold">
          4. Authentication and Hosting
        </h2>

        <p className="mb-4">
          TeamKitty uses secure third-party infrastructure providers including
          Amazon Web Services (AWS) and authentication services such as Amazon
          Cognito.
        </p>

        <h2 className="mt-6 mb-2 text-xl font-semibold">
          5. Cookies and Similar Technologies
        </h2>

        <p className="mb-4">
          TeamKitty uses cookies and similar technologies required for login,
          security, payment processing and core platform functionality.
        </p>

        <h2 className="mt-6 mb-2 text-xl font-semibold">
          6. Sharing Information
        </h2>

        <p className="mb-4">
          We do not sell personal information. Information may be shared with
          trusted service providers only where required to operate the platform.
        </p>

        <h2 className="mt-6 mb-2 text-xl font-semibold">
          7. Security
        </h2>

        <p className="mb-4">
          We take reasonable steps to protect information from unauthorized
          access, misuse or disclosure.
        </p>

        <h2 className="mt-6 mb-2 text-xl font-semibold">
          8. Your Rights
        </h2>

        <p className="mb-4">
          You may request access to, correction of, or deletion of your personal
          information using our{" "}
          <a href="/delete-account" className="text-[#0F766E] underline">
            account deletion page
          </a>{" "}
          or by contacting us.
        </p>

        <h2 className="mt-6 mb-2 text-xl font-semibold">
          9. Changes to this Policy
        </h2>

        <p className="mb-4">
          We may update this Privacy Policy from time to time. Continued use of
          TeamKitty indicates acceptance of any updated policy.
        </p>

        <p className="mt-8 text-sm text-slate-500">
          Contact:{" "}
          <a
            href="mailto:contact@teamkitty.io"
            className="text-[#0F766E] underline"
          >
            contact@teamkitty.io
          </a>
        </p>
      </div>
    </main>
  );
}
